import * as HeroIamApi from 'api-services/HeroIamApi';
import { logout, logoutDone, logoutError } from 'redux-data/auth/actionCreators';
import persistAuthStatus from '../persistAuthStatus';
import initLogin from '../ProtectedRoute/initLogin';
const handleLogout = (constAccessParams, access_token, dispatch) => {
    persistAuthStatus('loggingOut');
    dispatch(logout());
    HeroIamApi.logout(constAccessParams.API_ID_HOSTNAME, {
        client_id: constAccessParams.API_ID_CLIENT_ID,
        access_token
    })
        .then(() => {
        persistAuthStatus('loggedOut');
        initLogin(constAccessParams);
        dispatch(logoutDone());
    })
        .catch(() => {
        dispatch(logoutError('logout_error'));
    });
};
export default handleLogout;
//# sourceMappingURL=index.js.map